<template>
  <layout
    :showuserinfo="false"
    :title="'Cukai Tanah: ' + cukai.no_hakmilik "
    :crumbs="crumbs"
    >
    <w-card bg-color="" class="mt3 table-hardcode">
          <hakmilik
            :cukai="cukai"
            />

          <!--tab-->
          <w-tabs
            class="mt3"
            :items="tabs"
            :no-slider="false"
            active-class="primary">
            <template #item-content.1>

                  <!-- -->
                  <z-page class="" title="Butiran Cukai">
                      <div class="w-card__content content-hardcode">
                          <table class="table-dashboard" width="100%">
                             <tbody>
                                <tr>
                                   <td width="50%">Pemilik</td>
                                   <td>{{ cukai.pemilik.nama }}</td>
                                </tr>
                                <tr>
                                   <td>No. KP</td>
                                   <td>{{ cukai.pemilik.no_kp }}</td>
                                </tr>
                                <tr>
                                   <td>No. Tel</td>
                                   <td>{{ cukai.pemilik.no_tel }}</td>
                                </tr>
                                <tr>
                                   <td>Alamat</td>
                                   <td>{{ cukai.pemilik.alamat_1 }}</td>
                                </tr>
                                <tr>
                                   <td>&nbsp;</td>
                                   <td>{{ cukai.pemilik.alamat2 }}</td>
                                </tr>
                             </tbody>
                          </table>
                      </div>
                  </z-page>
                  <!--/-->

            </template>

            <template #item-content.2>

                  <!-- -->
                  <z-page class="" title="Butiran Cukai">
                      <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                              <tr>
                                 <td width="16%">Perihal</td>
                                 <td width="16%">Amaun (RM)</td>
                                 <td width="16%">Diskaun (RM)</td>
                                 <td width="16%">Tahun Remisyen Dari</td>
                                 <td width="16%">Tahun Remisyen Hingga</td>
                                 <td width="16%">Remisyen (RM)</td>
                                 <td></td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                 <td>Cukai Tanah Tahunan</td>
                                 <td>70.00</td>
                                 <td>0.00</td>
                                 <td>0</td>
                                 <td>0</td>
                                 <td>0.00</td>
                                 <td>
                                    <w-button
                                      class="my1 mr2">
                                      Kemaskini
                                    </w-button>
                                 </td>
                              </tr>
                              <tr>
                                 <td>Cukai Tali Air</td>
                                 <td>108.75</td>
                                 <td>0.00</td>
                                 <td>0</td>
                                 <td>0</td>
                                 <td>0.00</td>
                                 <td>
                                    <w-button
                                      class="my1 mr2">
                                      Kemaskini
                                    </w-button>
                                 </td>
                              </tr>
                              <tr>
                                 <td>Jumlah</td>
                                 <td>178.75</td>
                                 <td>0.00</td>
                                 <td>&nbsp;</td>
                                 <td>&nbsp;</td>
                                 <td>0.00</td>
                                 <td></td>
                              </tr>
                           </tbody>
                        </table>
                      </div>
                  </z-page>

                  <p class="mt5 mb5 pl5">Jumlah Perlu Dibayar = Jumlah Amaun - Jumlah Diskaun - Jumlah&nbsp;Remisyen</p>

                  <z-page class="" title="Butiran Cukai">
                      <div class="w-card__content content-hardcode">
                          <table class="table-dashboard" width="100%">
                             <tbody>
                                <tr>
                                   <td>Jumlah Perlu Dibayar</td>
                                   <td width="16%" class="text-right">178.75</td>
                                </tr>
                                <tr>
                                   <td>Jumlah Telah Dibayar&nbsp;</td>
                                   <td class="text-right">173.15</td>
                                </tr>
                                <tr>
                                   <td>Diskaun Cukai Tanah Jan - Mei</td>
                                   <td class="text-right">-5.60</td>
                                </tr>
                                <tr>
                                   <td>Baki Perlu Dijelaskan</td>
                                   <td class="text-right">0.00</td>
                                </tr>
                             </tbody>
                          </table>
                      </div>
                  </z-page>
                  <!--/-->

            </template>

            <template #item-content.3>

                  <!-- -->
                  <z-page class="" title="Rekod Bayaran">
                      <div class="w-card__content content-hardcode">
                          <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                   <td width="14%">Status</td>
                                   <td width="14%">Jumlah (RM)</td>
                                   <td width="14%">Cara Bayar</td>
                                   <td width="14%">Tarikh</td>
                                   <td width="14%">Nama Pembayar</td>
                                   <td width="14%">No. Resit</td>
                                   <td width="14%">Resit batal</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                   <td>Aktif</td>
                                   <td>173.15</td>
                                   <td>Tunai</td>
                                   <td>16/2/2021</td>
                                   <td>Ahmad - 01135451430</td>
                                   <td>20210216HS00093</td>
                                   <td>-</td>
                                </tr>
                                <tr>
                                   <td>Aktif</td>
                                   <td>173.15</td>
                                   <td>Tunai</td>
                                   <td>25/2/2021</td>
                                   <td>Isa - 01114421948</td>
                                   <td>20200225JE00006</td>
                                   <td>-</td>
                                </tr>
                                <tr>
                                   <td>Aktif</td>
                                   <td>173.15</td>
                                   <td>Tunai</td>
                                   <td>25/2/2021</td>
                                   <td>Eiasa - 01114421948</td>
                                   <td>20190226RG00014</td>
                                   <td>-</td>
                                </tr>
                                <tr>
                                   <td>Aktif</td>
                                   <td>170.35</td>
                                   <td>Tunai</td>
                                   <td>12/2/2021</td>
                                   <td>Eiasa - 01114421948</td>
                                   <td>20190226RG00016</td>
                                   <td>-</td>
                                </tr>
                                <tr>
                                   <td>Aktif</td>
                                   <td>170.35</td>
                                   <td>Tunai</td>
                                   <td>13/2/2021</td>
                                   <td>Isa - 01114421948</td>
                                   <td>20170213RJ00014</td>
                                   <td>-</td>
                                </tr>
                                <tr>
                                   <td>Aktif</td>
                                   <td>171.75</td>
                                   <td>Tunai</td>
                                   <td>15/2/2021</td>
                                   <td>Isa Bin Yahya - 0195656142</td>
                                   <td>20160215RG00127</td>
                                   <td>-</td>
                                </tr>
                                <tr>
                                   <td>Aktif</td>
                                   <td>171.75</td>
                                   <td>Tunai</td>
                                   <td>17/2/2021</td>
                                   <td>&nbsp;</td>
                                   <td>1502170002090095</td>
                                   <td>-</td>
                                </tr>
                             </tbody>
                          </table>
                      </div>
                  </z-page>

                  <z-page class="mt3" title="Rekod Bayaran">
                      <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                              <tr>
                                 <td>Status</td>
                                 <td>Jumlah</td>
                                 <td>Cara Bayar</td>
                                 <td>Tarikh</td>
                                 <td>Nama Pembayar</td>
                                 <td>No Resit</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                 <td colspan="6">Tiada Data Bayaran Ditemui</td>
                              </tr>
                           </tbody>
                        </table>
                      </div>
                  </z-page>
                  <!-- -->

            </template>

            <template #item-content.4>
                <z-page class="" title="Mesej">
                      <div class="w-card__content content-hardcode">
                            Tiada Maklumat Berkaitan
                      </div>
                </z-page>
            </template>

            <template #item-content.5>

                  <!-- -->
                  <z-page class="" title="Jejak Audit">
                      <div class="w-card__content content-hardcode">
                          <table class="table-dashboard" width="100%">
                              <thead>
                                  <tr>
                                     <td width="20%">Nama Medan</td>
                                     <td width="20%">Sebelum</td>
                                     <td width="20%">Selepas</td>
                                     <td width="20%">Id Kemaskini</td>
                                     <td width="20%">Tarikh</td>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                     <td>AMAUN_DISKAUN</td>
                                     <td>-5.6</td>
                                     <td>0</td>
                                     <td>SISTEM</td>
                                     <td>31/03/2019 7:00:12 PM</td>
                                  </tr>
                                  <tr>
                                     <td>KOD_DISKAUN_ID</td>
                                     <td>7</td>
                                     <td>&nbsp;</td>
                                     <td>SISTEM</td>
                                     <td>31/03/2019 7:00:12 PM</td>
                                  </tr>
                                  <tr>
                                     <td>MODIFIED_DATE</td>
                                     <td>&nbsp;</td>
                                     <td>31-MAR-19 07.00.00.220483 PM</td>
                                     <td>SISTEM</td>
                                     <td>31/03/2019 7:00:12 PM</td>
                                  </tr>
                                  <tr>
                                     <td>MODIFIED_BY</td>
                                     <td>&nbsp;</td>
                                     <td>SISTEM</td>
                                     <td>SISTEM</td>
                                     <td>31/03/2019 7:00:12 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AMAUN_DISKAUN</td>
                                     <td>&nbsp;</td>
                                     <td>0</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AMAUN</td>
                                     <td>&nbsp;</td>
                                     <td>108.75</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>KOD_BENDEHARA_ID</td>
                                     <td>&nbsp;</td>
                                     <td>3</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>TAHUN</td>
                                     <td>&nbsp;</td>
                                     <td>2019</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AKAUN_ID</td>
                                     <td>&nbsp;</td>
                                     <td>41977</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AMAUN_DISKAUN</td>
                                     <td>&nbsp;</td>
                                     <td>0</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AMAUN</td>
                                     <td>&nbsp;</td>
                                     <td>70</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>KOD_BENDEHARA_ID</td>
                                     <td>&nbsp;</td>
                                     <td>1</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>TAHUN</td>
                                     <td>&nbsp;</td>
                                     <td>2019</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AKAUN_ID</td>
                                     <td>&nbsp;</td>
                                     <td>41977</td>
                                     <td>SETUP2019</td>
                                     <td>31/03/2018 5:54:39 PM</td>
                                  </tr>
                                  <tr>
                                     <td>AMAUN_DISKAUN</td>
                                     <td>-8.4</td>
                                     <td>0</td>
                                     <td>SISTEM</td>
                                     <td>30/04/2018 11:33:56 PM</td>
                                  </tr>
                               </tbody>
                          </table>
                      </div>
                  </z-page>
                  <!--/-->

            </template>

            <template #item-content.6>

              <!---->
                  <z-page class="" title="Ampun Hasil">
                      <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                          <thead>
                              <tr>
                                 <td>Bil.</td>
                                 <td>No. Rujukan</td>
                                 <td>No. MMK</td>
                                 <td>Kategori</td>
                                 <td>Tempoh</td>
                                 <td>Amaun Cukai (RM)</td>
                                 <td>Remisyen (%)</td>
                                 <td>Amaun Remisyen (RM)</td>
                                 <td>Baki Amaun Cukai (RM)</td>
                                 <td>Dokumen</td>
                                 <td>Status</td>
                                 <td></td>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                 <td>1.</td>
                                 <td>1234</td>
                                 <td>1234</td>
                                 <td>KERABAT DIRAJA</td>
                                 <td>12/1/2022 - 12/1/2022</td>
                                 <td>40.00</td>
                                 <td>10</td>
                                 <td>4.00</td>
                                 <td>36.00</td>
                                 <td>&nbsp;</td>
                                 <td>AKTIF</td>
                                 <td>PAPAR / KEMASKINI</td>
                              </tr>
                          </tbody>
                        </table>
                      </div>
                    </z-page>

                        <w-flex class="mt2" wrap align-center justify-end>

                            <inertia-link :href="$route('cukai-tanah.showampunhasil',cukai.id)" class="w-button primary--bg size--md my1 mr2 my1">
                            Daftar
                            </inertia-link>

                          </w-flex>
              <!---->

            </template>

            <template #item-content.7>
                <z-page class="" title="Pengecualian">
                      <div class="w-card__content content-hardcode">
                            Tiada Maklumat Berkaitan
                      </div>
                </z-page>
            </template>

            <template #item-content.8>
                <z-page class="" title="Penguatkuasaan">
                      <div class="w-card__content content-hardcode">
                            Tiada Maklumat Berkaitan
                      </div>
                </z-page>
            </template>


          </w-tabs>
          <!--/-->
    </w-card>

    <w-flex class="mt2" wrap align-center justify-end>


      <div class="spacer" />

      <w-button
        class="my1 mr2">
        Bil Cukai
      </w-button>

      <w-button
        class="my1 mr2">Maklumat Cukai
      </w-button>

      <w-button
        class="my1 mr2">Maklumat Syer
      </w-button>

      <w-button
        class="my1 mr2">Maklumat Cukai 2
      </w-button>

      <!--
      <inertia-link :href="$route('cukai-tanah.showampunhasil',cukai.id)" class="w-button primary--bg size--md my1 mr2 my1">
      Ampun Hasil
      </inertia-link>
      -->

    </w-flex>

  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'
import Hakmilik from '../Component/Hakmilik'

export default {
  extends: ZResource,
  props: {
    cukai: [Array, Object],
    items: [Array, Object],
  },
  components: {
    Hakmilik
  },
  data() {
    return {
        resourceurl: 'cukai-tanah',
        reload: true,
        crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Cukai Tanah', route: '/cukai-tanah/dashboard' },
        { label: 'Senarai', route: '/cukai-tanah/senarai' },
        { label: this.cukai.no_hakmilik, route: '/cukai-tanah/' + this.cukai.id },
          ],
        tabs: [
        { title: 'Pemilik', content: '' },
        { title: 'Butiran Cukai', content: '' },
        { title: 'Rekod Bayaran', content: '' },
        { title: 'Mesej', content: '' },
        { title: 'Jejak audit', content: '' },
        { title: 'Ampun Hasil', content: '' },
        { title: 'Pengecualian', content: '' },
        { title: 'Penguatkuasaan', content: '' },
        ],
          form: {
            },
        }
  },
  methods: {

  },
  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500

  },
}
</script>
